<form [formGroup]="shopifyForm" (ngSubmit)="connectShopify()" class="d-flex flex-column">
  <mat-form-field class="w-100">
    <input matInput formControlName="url" placeholder="Shopify url" type="text" required />
    <span matSuffix class="fw-bolder">.myshopify.com</span>
  </mat-form-field>

  <button mat-flat-button type="submit" color="primary" class="ms-auto">Installer</button>
</form>
